export function getHashParam(key) {
	const hash = window.location.hash.substr(1);

	const result = hash.split('&').reduce((res, item) => {
		const parts = item.split('=');
		const [left, right] = parts;
		res[left] = right;

		return res;
	}, {});

	return result[key];
}

export function getQueryString() {
	try {
		const url = window.location.href;
		return url.split('?')[1];
	} catch {
		return '';
	}
}

export function setQueryString(param) {
	try {
		window.history.pushState(null, null, `?id=${param}${window.location.hash}`);
	} catch {
		/// do nothing
	}
}

export function getQueryParam(key) {
	try {
		const url = window.location.href;
		key = key.replace(/[[\]]/g, '\\$&');
		const regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)');
		const results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	} catch {
		return '';
	}
}

export const setQueryParams = (params: { [key: string]: string }) => {
	try {
		let queryString = '?';
		const entries = Object.entries(params);
		entries.forEach(
			([key, value], idx) => (queryString += `${key}=${value}${idx < entries.length - 1 ? '&' : ''}`)
		);
		window.history.pushState(null, null, queryString);
	} catch {
		/// do nothing
	}
};

export function removeURLParameter(parameter) {
	// prefer to use l.search if you have a location/link object
	const urlparts = window.location.href.split('?');
	if (urlparts.length >= 2) {
		const prefix = encodeURIComponent(parameter) + '=';
		const pars = urlparts[1].split(/[&;]/g);

		// reverse iteration as may be destructive
		for (let i = pars.length; i-- > 0; ) {
			// idiom for string.startsWith
			if (pars[i].lastIndexOf(prefix, 0) !== -1) {
				pars.splice(i, 1);
			}
		}

		return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
	}
	return window.location.href;
}

export function getHomeUrl() {
	// @ts-ignore
	return getCurrentLangPretty() === 'en' ? '/en' : '/';
}

export function getCurrentLangPretty(): 'en' | 'is' {
	return document.documentElement.lang === 'is' ? 'is' : 'en';
}

export const getCurrentCulture = () => {
	return document.documentElement.lang === 'is' ? 'is' : 'en-us';
};

export const getNextLocale = () => {
	return document.documentElement.lang === 'is' ? 'en' : 'is';
};
